import React, { useEffect, useState } from 'react';
import { Button, Alert, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { toast } from 'react-toastify';
import services from '../../services';

const AddUser = ({ show, onHide, authUrl, updateAuthEmail, setAuthUrlData, authUrlData, setIsLoading }) => {

  const truncateUrl = (url, maxLength = 50) => {
    if (!url) return '';
    if (url.length <= maxLength) return url;
    return url.slice(0, maxLength) + '...';
  };

  const handleCopy = async (id) => {
    setIsLoading(true);
    try {
      const response = await services.email.updateAuthEmail(id);
      const url = response?.data?.authUrl
      if (url) {
        if (!navigator.clipboard) {
          try {
            const textarea = document.createElement('textarea');
            textarea.value = url;
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand('copy');
            document.body.removeChild(textarea);
            toast.success('Full URL copied to clipboard!');
          } catch (err) {
            console.error('Fallback copy failed:', err);
            toast.error('Failed to copy URL. Please copy manually.');
          }
          return;
        }

        navigator.clipboard.writeText(url)
          .then(() => {
            toast.success('Full URL copied to clipboard!');
          })
          .catch((err) => {
            console.error('Clipboard API failed:', err);


            try {
              const textarea = document.createElement('textarea');
              textarea.value = url;
              document.body.appendChild(textarea);
              textarea.select();
              document.execCommand('copy');
              document.body.removeChild(textarea);
              toast.success('Full URL copied to clipboard!');
            } catch (fallbackErr) {
              console.error('Fallback copy failed:', fallbackErr);
              toast.error('Failed to copy URL. Please copy manually.');
            }
          });
      }
    } catch (e) {
      console.error(e);
    } finally {
      setIsLoading(false);
    }
  };

  const handleOpen = async (client_id) => {
    setIsLoading(true);
    try {
      const response = await services.email.updateAuthEmail(client_id);
      const openUrl = response?.data?.authUrl

      if (openUrl) {
        const width = 500;
        const height = 400;
        const left = window.screen.width / 2 - width / 2;
        const top = window.screen.height / 3 - height / 2;

        window.open(
          openUrl,
          'Email Authorization',
          `width=${width},height=${height},top=${top},left=${left}`
        );
      }
    } catch (e) {
      console.error(e);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title className='md:py-[0.6vw]'>
          Please open the URL below to authorize.
        </Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ maxHeight: '500px', overflow: 'auto' }}>
        {authUrlData && authUrlData.length > 0 ? (
          <div className="py-2">
            <table className="min-w-full bg-white border border-gray-200 rounded-xl shadow-md overflow-hidden">
              <thead>
                <tr className="bg-gray-50 border-b-2 border-gray-200">
                  <th className="px-4 py-3 text-left text-xs font-semibold text-black uppercase">Project ID</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-black uppercase">Client ID</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-black uppercase">Action</th>
                </tr>

              </thead>
              <tbody>
                {authUrlData.map((item, index) => (
                  <tr key={index} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                    <td className="px-4 py-2 text-sm text-gray-800 whitespace-nowrap">
                      {item.project_id || 'N/A'}
                    </td>
                    <td className="px-4 py-2 text-sm text-gray-800 whitespace-nowrap">
                      {item.client_id
                        ? item.client_id.length > 15
                          ? `${item.client_id.substring(0, 15)}...`
                          : item.client_id
                        : 'N/A'}
                    </td>
                    <td className="px-4 py-2 text-sm text-gray-800 whitespace-nowrap">
                      <div className="flex gap-2">
                        <button
                          onClick={() => handleCopy(item.client_id)}
                          className="text-xs px-2 py-1 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-100"
                          title="Copy URL to clipboard"
                        >
                          Copy URL
                        </button>
                        <button
                          onClick={() => handleOpen(item.client_id)}
                          className="text-xs px-2 py-1 border border-blue-400 text-blue-600 rounded-md hover:bg-blue-50"
                          title="Open URL in new window"
                        >
                          Open URL
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="text-center text-gray-500 py-8">No authorization URL available.</div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default AddUser;
